<template>
  <VModal :type="ModalType.custom" :color="ColorType.gray" :isScroll="false">
    <div>
      <VBlock class="giftcard-wrapper" :sort="Sort.left_top" :direction="Direction.column">
        <VBlock class="giftcard-header" :sort="Sort.space_between">
          <VBlock class="stock-wrapper">
            <VStockButton
              :type="StockButtonType.exit"
              :clickEvent="onExit"
              :width="16"
              :height="16"
            />
          </VBlock>
          <VSpan class="text" text="선물함" :size="16" :weight="TextWeight.bold" />
          <div class="blank"></div>
        </VBlock>

        <VBlock
          :class="['giftcard-contents',selectedGiftCards.length > 0 && showPreOrderGiftSelection && 'giftcard-margin-bottom']"
          ref="scrollLayer"
          :sort="Sort.left_top"
          :direction="Direction.column"
        >
          <VList class="giftcard-list" v-if="params.giftCards.length > 0">
            <VListItem
              class="giftcard-list-item"
              v-for="giftCard in params.giftCards"
              :key="giftCard.giftcardNumber"
            >
              <VBlock
                :onClick="invalidCards
                      .map(card => card.giftcardNumber)
                      .includes(giftCard.giftcardNumber) ?()=>null :() => setSelectedGiftCards(giftCard)"
              >
                <VCard
                  :class="[
                    'giftcard',
                    invalidCards
                      .map(card => card.giftcardNumber)
                      .includes(giftCard.giftcardNumber) && 'invalid-giftcard'
                  ]"
                  :radius="15"
                >
                  <VBlock class="giftcard-image-wrapper">
                    <VImage
                      class="giftcard-image"
                      :width="108"
                      :height="144"
                      :src="giftCard.thumbnailImageUrl"
                    />
                    <VBlock :direction="Direction.column" class="giftcard-dot-wrapper">
                      <VImage
                        :src="resources.decoDotIcon"
                        :width="3"
                        :height="9"
                        v-for="index in 16"
                        :key="index"
                      />
                    </VBlock>
                  </VBlock>
                  <VBlock
                    class="giftcard-content"
                    :direction="Direction.column"
                    :sort="Sort.space_between"
                  >
                    <VSpan
                      :text="`${giftCard.balance.toLocaleString()}원`"
                      :color="TextColor.warning"
                      :size="30"
                      :weight="TextWeight.bold"
                      class="giftcard-price"
                    />
                    <VBlock :direction="Direction.column" :sort="Sort.left_center">
                      <VBlock :direction="Direction.row" :sort="Sort.left_center">
                        <VP :text="`${giftCard.letterFrom}`" :size="14" class="giftcard-sender" />
                        <VP text="님" :size="14" />
                        <div class="divider" />
                        <VP :text="`${giftCard.faceValue.toLocaleString()}원`" :size="14" />
                      </VBlock>
                      <VP
                        class="giftcard-date"
                        :text="`${giftCard.purchaseDateTime} ~ ${giftCard.availableDate}`"
                        :size="14"
                      />
                    </VBlock>
                  </VBlock>
                  <VImage
                    v-if="
                      !invalidCards
                        .map(card => card.giftcardNumber)
                        .includes(giftCard.giftcardNumber)
                    "
                    :src="
                      selectedGiftCards
                        .map(card => card.giftcardNumber)
                        .includes(giftCard.giftcardNumber)
                        ? resources.checkboxActiveIcon
                        : resources.checkboxInActiveIcon
                    "
                    :width="24"
                    :height="24"
                    class="giftcard-checkbox"
                  />
                  <div
                    class="giftcard-invalid-checkbox"
                    v-if="
                      invalidCards
                        .map(card => card.giftcardNumber)
                        .includes(giftCard.giftcardNumber)
                    "
                  />
                </VCard>
              </VBlock>
            </VListItem>
          </VList>
          <VBlock
            class="giftcard-empty"
            :direction="Direction.column"
            v-if="params.giftCards.length === 0"
          >
            <VImage :width="240" :height="240" :src="resources.emptyIcon" class="empty-image" />
            <VP text="사용 가능한 상품권이 없습니다" :size="14" />
          </VBlock>
        </VBlock>

        <VBlock class="giftcard-footer" :direction="Direction.column">
          <VButton
            class="giftcard-apply-button"
            :onClick="isGiftCardEmpty ? () => resetGiftCards() : () => null"
            :radius="4"
            :color="isGiftCardEmpty ? ButtonColor.brand : ButtonColor.inactive"
            :style="isGiftCardEmpty ? { opacity: '1' } : { opacity: '0.3' }"
          >
            <VSpan
              :text="`${isGiftCardEmpty ? '사용 취소하기' : '상품권을 선택해주세요'}`"
              :size="18"
              :weight="TextWeight.bold"
              :color="TextColor.white"
            />
          </VButton>
        </VBlock>
      </VBlock>

      <PreOrderGiftSelection
        v-if="selectedGiftCards.length > 0 && showPreOrderGiftSelection"
        :onOK="() => null"
        :onCancel="() => null"
        :selectedGiftCards="selectedGiftCards"
        :totalGiftCardsPrices="totalGiftCardsPrices"
        :totalGiftCardsSelectedPrices="totalGiftCardsSelectedPrices"
        :isNotValid="isNotValid"
        :confirmMessage="confirmMessage"
        :validate="validate"
      />
      <div class="modal-wrapper" v-if="isOverPaymentPrice || isNotValid">
        <div class="overlay" />
        <div class="modal-contents">
          <ModalCheck :message="confirmMessage" :onOK="() => onConfirmOk()" />
        </div>
      </div>
    </div>
  </VModal>
</template>

<script>
import VHR, { LineColor } from '@/presentationals/v2/components/layouts/atoms/VHR'
import VP from '../../atoms/VP'
import VA from '@/presentationals/v2/components/layouts/molecules/VA'

import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VStockButton, {
  StockButtonType
} from '@/presentationals/v2/components/layouts/atoms/VStockButton'
import VImage from '@/presentationals/v2/components/layouts/atoms/VImage'

import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VCard from '@/presentationals/v2/components/layouts/molecules/VCard'
import VList from '@/presentationals/v2/components/layouts/molecules/VList'
import VListItem from '@/presentationals/v2/components/layouts/molecules/VListItem'
import VModal, {
  ModalType,
  ColorType
} from '@/presentationals/v2/components/layouts/molecules/VModal'
import PreOrderGiftSelection from '@/presentationals/v2/components/layouts/organisms/PreOrderGiftSelection'
import ModalCheck from '@/presentationals/v2/components/layouts/organisms/Modals/ModalCheck'

import selectedIcon from '@/assets/images/confirm-input-24.svg'
import checkboxActiveIcon from '@/assets/images/checkbox-right-on.svg'
import checkboxInActiveIcon from '@/assets/images/checkbox-right-off.svg'
import decoDotIcon from '@/assets/images/deco-coupon-dot-line.svg'
import emptyIcon from '@/assets/images/image-no-item.png'

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default {
  name: 'ModalGiftCard',
  props: {
    title: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function
    },
    params: {
      type: Object,
      required: true
    }
  },
  components: {
    VP,
    VButton,
    VHR,
    VA,
    VImage,
    VSpan,
    VStockButton,
    VBlock,
    VCard,
    VList,
    VListItem,
    VModal,

    PreOrderGiftSelection
  },
  methods: {
    onExit() {
      this.onCancel()
    },
    setSelectedGiftCards(giftCard) {
      const updatedGiftCards = [
        ...this.selectedGiftCards,
        { ...giftCard, spentAmount: giftCard.balance }
      ]

      const alreadySelectedTotal = this.selectedGiftCards.reduce(
        (prev, next) => prev + next.balance,
        0
      )
      const alreadyHasGiftCard = this.selectedGiftCards.some(
        card => card.giftcardNumber === giftCard.giftcardNumber
      )

      let beforeGiftAmount = alreadySelectedTotal + this.totalPaymentPrice

      // 이미 선택 했을시,
      if (alreadyHasGiftCard) {
        let beforeGiftAmountWhenHasGift = this.selectedGiftCards.reduce((acc, curr) => {
          return acc + curr.spentAmount
        }, 0)

        const filteredGiftCards = (this.selectedGiftCards = this.selectedGiftCards.filter(
          card => card.giftcardNumber !== giftCard.giftcardNumber
        ))

        this.selectedGiftCards = filteredGiftCards
          .map(giftCard => {
            if (beforeGiftAmountWhenHasGift <= 0) {
              return
            }

            const caculatedSpentAmount =
              beforeGiftAmountWhenHasGift < giftCard.balance
                ? beforeGiftAmountWhenHasGift
                : giftCard.balance
            if (beforeGiftAmountWhenHasGift > giftCard.balance)
              beforeGiftAmountWhenHasGift -= giftCard.balance
            return { ...giftCard, spentAmount: caculatedSpentAmount }
          })
          .filter(Boolean)

        this.params.onSelectGiftCards(this.selectedGiftCards)
        this.showPreOrderGiftSelection = true
        return
      }

      if (this.totalPaymentPrice === 0) {
        // 결제금액 초과 case
        this.confirmMessage = '상품권이 결제금액을 초과하였습니다.'
        this.onConfirmOk = () => {
          this.isOverPaymentPrice = false
        }
        this.isOverPaymentPrice = true
        return
      }

      // 이떄는 우선순위를 적용한다. (우선순위가 제일 낮은것에다가, spentAmount를 업데이트 쳐준다. 다른것들은 그대로 사용)
      // 1순위) 유효기간 종료일이 가까운 순
      // 2순위) 유효기간 종료일이 동일한 경우 상품권 권면금액이 큰 순
      // 3순위) 유효기간 종료일과 상품권 권면금액이 동일한 경우 상품권 발행번호(시간) 오래된순 (선물할 사람이 상품권을 만든 시점 기준)
      const calculatedGiftCards = updatedGiftCards
        .slice()
        .sort((prev, next) => prev.priority - next.priority)
        .map(giftCard => {
          if (beforeGiftAmount <= 0) {
            return
          }
          const calculatedSpentAmount =
            beforeGiftAmount < giftCard.balance ? beforeGiftAmount : giftCard.balance
          beforeGiftAmount -= giftCard.balance
          return { ...giftCard, spentAmount: calculatedSpentAmount }
        })
        .filter(Boolean)

      this.selectedGiftCards = [...calculatedGiftCards]
      this.params.onSelectGiftCards(this.selectedGiftCards)
      this.showPreOrderGiftSelection = true
    },
    async validate() {
      const { result } = await this.$store.dispatch('preOrder/doGiftCardValidate', {
        appliedGiftCards: this.selectedGiftCards
      })

      if (result.valid) {
        this.validateFinished = true
        this.$store.dispatch('modal/close')
      } else {
        this.invalidCards = [...this.invalidCards, ...result.invalidCards] || []
        this.isNotValid = true
        this.confirmMessage = result.message
        this.onConfirmOk = () => {
          this.isNotValid = false
        }
        this.selectedGiftCards = this.selectedGiftCards
          .filter(card => result.invalidCards.includes(card.giftcardNumber))
          .map(card => {
            return { ...card, spentAmount: card.balance }
          })
        this.validateFinished = true
        this.params.onSetInvalidGiftCards(this.invalidCards)
        this.params.onSelectGiftCards(this.selectedGiftCards)
      }
    },
    resetGiftCards() {
      this.params.onSelectGiftCards([])
      this.$store.dispatch('modal/close')
    }
  },
  computed: {
    isGiftCardSelected() {
      return this.params.selectedGiftCards.length > 0
    },
    totalPaymentPrice() {
      return this.$store.getters['preOrder/totalPaymentPrice']
    },
    totalGiftCardsPrices() {
      return this.selectedGiftCards.reduce((prev, next) => prev + next.balance, 0)
    },
    totalGiftCardsSelectedPrices() {
      return this.selectedGiftCards.reduce((prev, next) => prev + next.spentAmount, 0)
    },
    isGiftCardEmpty() {
      return this.hasGiftCardsWhenEnter && this.selectedGiftCards.length === 0
    }
  },
  created() {
    const { appVersion } = this.$store.getters
    this.$store.commit('hideNavigationBar', { appVersion })
  },
  mounted() {
    if (this.selectedGiftCards.length > 0) {
      this.hasGiftCardsWhenEnter = true
    }
    if (!!this.$refs.scrollLayer) disableBodyScroll(this.$refs.scrollLayer.$el)
  },
  beforeDestroy() {
    const { appVersion } = this.$store.getters
    if (!this.validateFinished) {
      const giftCards = this.prevSelectedGiftCards.length > 0 ? this.prevSelectedGiftCards : []

      !this.isGiftCardEmpty && this.params.onSelectGiftCards([...giftCards])
    }
    this.$store.commit('showNavigationBar', { appVersion })

    if (!!this.$refs.scrollLayer) enableBodyScroll(this.$refs.scrollLayer.$el)
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort,
      ModalType,
      StockButtonType,
      ColorType,
      LineColor,
      hasGiftCardsWhenEnter: false,
      invalidCards: this.params.invalidCards,
      selectedGiftCards: this.params.selectedGiftCards,
      prevSelectedGiftCards: this.params.selectedGiftCards.slice(),
      isOverPaymentPrice: false,
      isNotValid: false,
      validateFinished: false,
      confirmMessage: '',
      showPreOrderGiftSelection: false,
      onConfirmOk: () => null,

      resources: {
        checkboxActiveIcon,
        checkboxInActiveIcon,
        decoDotIcon,
        emptyIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.divider {
  width: 1px;
  height: 10px;
  margin: 0px 5px;
  background-color: #d7d7d7;
}

.modal-wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
}

.modal-contents {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 300px;
  height: 149px;
}

.overlay {
  position: absolute;
  top: 0;
  padding: 32px;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
}

.giftcard-empty {
  height: inherit;
  .empty-image {
    margin-bottom: 31px;
  }
}

.giftcard-wrapper {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background-color: $background-gray;

  .giftcard-sender {
    max-width: 55%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    @media screen and (max-width: 320px) {
      max-width: 40%;
    }
  }

  .giftcard-header {
    padding: 10px 15px 10px 15px;
    align-items: center;
    box-sizing: border-box;
    background-color: $background-white;
    border-bottom: 1px solid $light-gray-4;
    z-index: 1;

    .text {
      height: 19px;
      vertical-align: middle;
    }

    .stock-wrapper {
      width: 24px;
      height: 24px;
    }

    .blank {
      width: 30px;
    }
  }

  .invalid-giftcard {
    img {
      opacity: 0.4;
    }

    span,
    p {
      color: #bbbbbb;
    }
  }

  .giftcard-margin-bottom {
    margin-bottom: 121px;
  }

  .giftcard-contents {
    width: 100%;
    height: calc(100vh - 95px);
    height: calc(100vh - (constant(safe-area-inset-bottom) - 95px));
    height: calc(100vh - (env(safe-area-inset-bottom) - 95px));
    padding: 20px;
    box-sizing: border-box;
    overflow-y: auto;
    position: relative;

    .footer-wrapper {
      position: relative;
      width: 100%;
      height: 50px !important;

      .hr-line {
        width: 100%;
        margin-bottom: 12px;
      }

      .footer-description-wrapper {
        width: 100%;
        height: auto;
        padding: 0 12px 0 12px;
      }
    }

    .giftcard-image-wrapper {
      position: relative;
      width: 108px;
    }

    .giftcard-list {
      height: auto;
      box-sizing: border-box;
      border-radius: 15px;

      .giftcard-list-item {
        width: 100%;
        margin-bottom: 15px;
        box-shadow: 0 2px 8px 0 rgba(34, 34, 34, 0.12);
        position: relative;
        border-radius: 15px;
        .giftcard-dot-wrapper {
          width: auto;
          position: absolute;
          right: -1px;
        }

        .giftcard {
          width: 100%;
          box-sizing: border-box;

          border-radius: 1px solid $light-gray-6;

          display: flex;
          @media screen and (max-width: 320px) {
            & .giftcard-price {
              font-size: 22px !important;
            }
          }

          & .giftcard-image {
            border-radius: 15px 0px 0px 15px !important;
          }

          & .giftcard-content {
            width: calc(100% - 108px);
            padding: 20px 0px 22px 20px;
            & .giftcard-date {
              text-align: left;
              font-size: 12px !important;
            }
          }

          & .giftcard-checkbox {
            position: absolute;
            right: 24px;
            top: 24px;
            @media screen and (max-width: 320px) {
              right: 20px;
              top: 20px;
            }
          }
          & .giftcard-invalid-checkbox {
            position: absolute;
            right: 24px;
            top: 24px;
            width: 24px;
            height: 24px;
            border: solid 2px #e6e6e6;
            background-color: #ffffff;
            border-radius: 50%;
          }
        }
      }
    }
  }

  .giftcard-footer {
    width: 100%;
    height: 50px !important;
    box-sizing: border-box;
    padding: 0 10px;
    margin-bottom: 10px;
    margin-bottom: calc(constant(safe-area-inset-bottom) + 10px);
    margin-bottom: calc(env(safe-area-inset-bottom) + 10px);

    .giftcard-apply-button {
      width: 100%;
      height: 50px !important;
    }
  }
}
</style>
